import { FadeUp } from "./Reveal";

const ITEMS = [
  {
    n: "01",
    t: "Specialist travel technology",
    d: "SaaS products and custom builds for tour operators, DMCs and agencies.",
  },
  {
    n: "02",
    t: "Technology for every business",
    d: "Design, software, digital marketing and AI products.",
  },
];

export default function IntroSplit() {
  return (
    <section className="bg-ink pb-24 pt-2">
      <div className="mx-auto grid max-w-[1160px] gap-12 px-6 md:grid-cols-2">
        {ITEMS.map((it, i) => (
          <FadeUp key={it.n} delay={i * 0.1} className="border-t border-white/[0.14] pt-9">
            <p className="text-[15px] font-medium text-brand" data-testid={`intro-number-${it.n}`}>
              {it.n}
            </p>
            <h3 className="mt-7 text-[26px] font-medium tracking-[-0.01em] text-white">
              {it.t}
            </h3>
            <p className="mt-3 max-w-[430px] text-[16px] leading-[1.6] text-[#9a9aa3]">{it.d}</p>
          </FadeUp>
        ))}
      </div>
    </section>
  );
}
